import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '@getpopsure/qnr-framework';
import BasicQuote from 'features/legal/components/Quote/Quote';

export type ExtractProps<T> = T extends (args: infer K) => JSX.Element
  ? K
  : never;

// Add new custom quote types here
type CustomQuoteType = 'BASIC';

// @TODO once starting to implement the first real quote page - remove this comment
// For setting up the component: the `Basic` type maps to the legal quote.
// Once starting to add the first real quote page - provide the correct name and map
// to the quote page component. Also update the cms with the added custom quote name.
const getComponentAndProps = (customQuote: CustomQuoteType, props: unknown) => {
  switch (customQuote) {
    case 'BASIC':
      return {
        Component: BasicQuote,
        componentProps: props as ExtractProps<typeof BasicQuote>,
      };
    default:
      return {};
  }
};

export const QuoteCustom = <Questionnaire extends QuestionnaireQuestions>({
  customQuote,
  ...props
}: QuestionnaireFormProps<Questionnaire> & {
  customQuote: CustomQuoteType;
}) => {
  const { Component, componentProps } = getComponentAndProps(
    customQuote,
    props
  );

  if (Component !== undefined && componentProps !== undefined) {
    return <Component {...componentProps} />;
  }

  return <></>;
};
